import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LayerFilterCategory } from 'projects/leaflet/src/public-api';
import { DescDialogComponent } from '../desc-dialog/desc-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FilterService } from 'projects/frontend/src/app/services/filter.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'emodnet-menu-selected',
  templateUrl: './menu-selected.component.html',
  styleUrls: ['../menu/menu.component.scss']
})
export class MenuSelectedComponent implements OnInit {

  public customId:any = {id:''};

  @Output() filtersSelected: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() categories?: any[];
  @Input()
  public set setCustom(custom : any) {
    if (!custom) return;
    this.customId = custom;
  }

  constructor(public dialog: MatDialog,
    private filterService: FilterService,
    private OAuth: OAuthService) {}

  ngOnInit(): void {}

  get token() {
    return this.OAuth.getAccessToken();
  }

  selectFilters(category: LayerFilterCategory, selected: boolean) {
    category.selected = selected;
    category.filters?.forEach(f => f.selected = selected);
    this.filtersSelected.emit(true);
  }

  public openDialog(e: any, description: string, title: string) {
    e.stopPropagation();
    e.preventDefault();
    this.dialog.open(DescDialogComponent, {
      data: {
        title: title,
        desc: description,
      }
    });
  }
}
